import { application } from "./application"

import { registerControllers } from "stimulus-vite-helpers"
import { Modal } from "tailwindcss-stimulus-components"

const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
registerControllers(application, controllers)

application.register("modal", Modal)
